var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"stage",staticClass:"game-stage"}),_c('UiControlComponent'),_c('GameOverOverlay')],1)}
var staticRenderFns = []

export { render, staticRenderFns }